import padStart from "lodash/padStart";
import { validateModulo } from "./isBankAccountNumber";

export function isBankPrefixNumber(value: string) {
  let valid = true;

  if (value) {
    const regex = /^([0-9]{2,6})$/;
    valid = regex.test(value);

    if (valid) {
      const accountPrefix = padStart(value, 6, "0");
      valid = validateModulo(accountPrefix, [10, 5, 8, 4, 2, 1]);
    }
  }

  return valid;
}
